import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  myRate: {
    fontSize: 14,
    fontWeight: isKiteUser ? '700' : '600',
    '& > legend': {
      fontSize: 14,
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
      '& > legend': {
        fontSize: 16,
      },
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      fontWeight: '400',
      '& > legend': {
        fontSize: 14,
      },
    },
  },
}));
